var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappy = function SvgHappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M17 32.5c8.56 0 15.5-6.94 15.5-15.5S25.56 1.5 17 1.5 1.5 8.44 1.5 17 8.44 32.5 17 32.5m0 1.5C7.611 34 0 26.389 0 17S7.611 0 17 0s17 7.611 17 17-7.611 17-17 17"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 13,
    rx: 1.75,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23,
    cy: 13,
    rx: 1.75,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M9.472 23.53c1.913 1.92 4.437 2.88 7.528 2.88s5.616-.96 7.53-2.88a.75.75 0 1 0-1.063-1.06c-1.62 1.627-3.76 2.44-6.467 2.44s-4.846-.813-6.465-2.44a.75.75 0 1 0-1.063 1.06"
  }))));
};
export default SvgHappy;